import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { Component, ViewChild, AfterViewInit, Injectable, Inject } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { authManager } from './helpers/authManager';
import { environment } from '@environment/environment';
import { HttpClient } from '@angular/common/http';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthService } from './service/auth.service';
import { AdminService } from './admin/Service/admin.service';


declare var $: any;
@Component({
    template: '<div></div>'

})

export class LandingComponent implements OnInit {

    state: string;
    selectedMenuItem: string;
    SSO: any;
    UserRoleID: any;
    userId: any;
    responseDetails: any[] = [];
    role: any;
    userstatus: any;
    Tocheck : any;

    constructor(private router: Router, private AuthManager: authManager, private adminService: AdminService) { 
        //debugger;
    }
    ngOnInit() {
        //debugger;

        this.SSO = Number(this.AuthManager.dynSSOId);


        if ((this.SSO) >= 0) {
            if (sessionStorage.getItem('referenceUrl')) {

                window.location.href = sessionStorage.getItem('referenceUrl');
                sessionStorage.removeItem('referenceUrl');
            } else {


                this.adminService.getUserRoleID(this.SSO).subscribe(
                    p => {
                       // debugger;
                        this.responseDetails = p;
                        this.UserRoleID = this.responseDetails[0].roles.roleID;
                        this.userId = this.responseDetails[0].userID;
                        sessionStorage.setItem('userid', this.userId);

                         this.Tocheck = sessionStorage.getItem('userid');

                        if (this.UserRoleID === 1) {
                            window.location.href = environment.stage.appurl + '/#/Admin';
                        } else if (this.UserRoleID === 2) {
                            window.location.href = environment.stage.appurl + '/#/Admin';
                        } else if (this.UserRoleID === 3 && (this.Tocheck != null || this.Tocheck != undefined || this.Tocheck != ""))
                        {
                            window.location.href = environment.stage.appurl + '/#/TransactionRefund';
                        } else if (this.UserRoleID === 4) {
                            window.location.href = environment.stage.appurl + '/#/RefundApprove';
                        } else {
                            window.location.href = environment.stage.appurl + '/#/Login';
                        }
                    });
            }
        } else {
            if (sessionStorage.getItem('referenceUrl')) {

                window.location.href = sessionStorage.getItem('referenceUrl');
                sessionStorage.removeItem('referenceUrl');
            } else {

                window.location.href = environment.stage.appurl + '/#/Login';
            }
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/landing.component.ts